import {axiosInstance} from './axios';

export  function getLastLiveLocation(query='') {
  try {
    return  axiosInstance.get(`/api/v1/live-location?${query}`)
  }catch (e) {
    return null;
  }
}

export  function getTravelsLocations() {
  try {
    return  axiosInstance.get('/api/v1//travels-locations')
  }catch (e) {
    return null;
  }
}